export default __webpack_public_path__ + "static/lws_3-2-84e156908ed62d29d9ddb2c84e1f8a38.jpg";